import { ResolveParams } from "@/core/models/routing";
import { useCoreStore, useIndexesStore } from "@/stores";
import { IDirectoryContentRequest, IDirectoryItem } from "@/stores/indexes/models";
import { storeToRefs } from "pinia";
import { reactive } from "vue";

export default () => {
    const store = useIndexesStore();
    const { useSilentApiCall } = storeToRefs(useCoreStore());

    const loadIndexDossier = async (resolveParams: ResolveParams) =>{
        await store.getIndexById(resolveParams)
        .then(()=>{
            if(!store.libraryOnFocus?.driveId || store.librariesContents[store.libraryOnFocus?.driveId]) return
            getDirectoryContent(null, null, [store.libraryOnFocus.name]);
        })
    }

    const getDirectoryContent = async (folder: IDirectoryItem | null = null, folderId: string | null = null, path: string[] = []) => {
        useSilentApiCall.value = folderId !== null;
        const libraryOnFocus = store.libraryOnFocus;
    
        try {
            
            const resp = await store.fetchDirectoryContent({driveId: libraryOnFocus?.driveId, folderId} as IDirectoryContentRequest);
            const mapped = arrayToMap(resp, path);
            setChildrens(mapped, folder, folderId);
                
            for (const item of Object.values(mapped)) {
                if (item.type === null) {
                    await getDirectoryContent(item, item.id, [...path, item.name]);
                }
            }
        } finally {
            useSilentApiCall.value = false;
        }
    };

    const arrayToMap = (items: IDirectoryItem[], path: string[]): Record<string, IDirectoryItem> => {
        const map: Record<string, IDirectoryItem> = {};
        for (const item of items) {
            const newItem: IDirectoryItem = reactive({
                ...item,
                path: [...path],
                isLoaded: item.type === null ? false : undefined
            });
            map[newItem.name] = newItem;
        }
        return map;
    };

    const setChildrens = (obj: Record<string, IDirectoryItem>, folder: IDirectoryItem | null, folderId: string | null) => {
        const libraryOnFocus = store.libraryOnFocus;

        if (libraryOnFocus?.driveId && folderId === null) {
            store.librariesContents[libraryOnFocus.driveId] = obj;
        } else if (folder !== null) {
            Object.assign(folder, {
                childrens: obj,
                isLoaded: true
            });
        }
    }

    return {
        arrayToMap,
        setChildrens,
        getDirectoryContent,
        loadIndexDossier
    }
}